/**
 * User: nir
 * Date: 25/09/2016
 * Time: 13:02
 */

if (window.jQuery) {
    window.jQuery(function ($) {
        var locationWidgets = $('#location-widgets'),
            locationMain = $('#location'),
            dstOffset = null,
            rawOffset = null,
            timeInput = null;

        function timeInit() {
            var locationId = locationMain.attr('data-id'),
                data = {
                    action: 'tct_insert_location_widget',
                    locationID: locationId
                };
            // make AJAX call
            $.post(window['TCTServer']['ajax_url'], data, "json")
                .success(function (response) {
                    if (response.status && response.html !== null) {
                        locationWidgets.append(response.html);

                        dstOffset = $('[data-dst-offset]').data('dst-offset');
                        rawOffset = $('[data-raw-offset]').data('raw-offset');
                        timeInput = $('#time-zone');
                        if (dstOffset != null &&
                            rawOffset != null &&
                            timeInput && timeInput.length) {

                            TCT.debug('LOCATION WIDGETS - INIT');

                            // immediate output
                            var second = setTimeZone();

                            TCT.debug('LOCATION WIDGETS - second=', second);

                            setTimeout(run, 60000 - (1000 * second));
                        }
                    }
                })
                .error(function (response) {
                });
        }

        function run() {
            // further minutes output
            setInterval(setTimeZone, 60000);

            // first minute output
            setTimeZone();
        }

        function setTimeZone() {
            var timeStamp = Date.now() / 1000,
                localDate = new Date((timeStamp + dstOffset + rawOffset) * 1000),
                timeArray = localDate.toUTCString().split(' ')[4].split(':');

            timeInput.html(timeArray[0] + ':' + timeArray[1]);

            TCT.debug('LOCATION WIDGETS - timeArray=', timeArray);

            return parseInt(timeArray[2]);
        }

        if (locationWidgets.length !== 0 && locationMain.length !== 0)
            timeInit();
    });
}